import {
  type DatasourceDetailsRequest,
  type DatasourceDataRequest,
  type DatasourceDataResponse,
  type DatasourceDetailsResponse,
} from '@atlaskit/linking-types';

import { AtlassianClient } from './../atlassian-client';
import { type Fetcher } from './../atlassian-client-types';

export class DatasourceClient {
  private atlassianClient: AtlassianClient;

  constructor(fetcher: Fetcher, baseUrl: URL) {
    this.atlassianClient = new AtlassianClient(fetcher, baseUrl);
  }

  public getData(
    datasourceId: string,
    params: DatasourceDataRequest,
    headers?: HeadersInit
  ) {
    return this.atlassianClient.post<Record<string, any>, DatasourceDataResponse>(
      `/datasource/${datasourceId}/fetch/data`,
      params,
      headers
    );
  }

  public getDetails(datasourceId: string, params: DatasourceDetailsRequest) {
    return this.atlassianClient.post<Record<string, any>, DatasourceDetailsResponse>(
      `/datasource/${datasourceId}/fetch/details`,
      params
    );
  }
}
